import { lazy, Suspense, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import SearchSection from "@/components/SearchSection";
import ListingsGrid from "@/components/ListingsGrid";
import { fetchListings, type ListingFilters } from "@/lib/listings";

const FeaturesSection = lazy(() => import("@/components/FeaturesSection"));
const NeighborhoodsSection = lazy(() => import("@/components/NeighborhoodsSection"));
const ContactSection = lazy(() => import("@/components/ContactSection"));
const Footer = lazy(() => import("@/components/Footer"));
const WhatsAppFloatingButton = lazy(() => import("@/components/WhatsAppFloatingButton"));
const LaunchesCarousel = lazy(() => import("@/components/LaunchesCarousel"));

const Index = () => {
  const [filters, setFilters] = useState<ListingFilters>({});

  const { data: listings = [], isLoading } = useQuery({
    queryKey: ["listings", filters],
    queryFn: () => fetchListings(filters),
  });

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="pt-16">
        <HeroSection />
        <SearchSection onSearch={setFilters} />
        <ListingsGrid listings={listings} isLoading={isLoading} />
        <Suspense fallback={null}>
          <LaunchesCarousel />
          <FeaturesSection />
          <NeighborhoodsSection />
          <ContactSection />
          <Footer />
          <WhatsAppFloatingButton />
        </Suspense>
      </main>
    </div>
  );
};

export default Index;
